<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Definicje faktur</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Faktury:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Aktywne i zablokowane</option>
          <option value="only">Tylko zablokowane</option>
        </select>

        <label class="mt-4 block text-gray-700">Magazyn:</label>
        <multiselect-input v-model="form.storeroom" :options="storerooms" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />

        <label class="mt-4 block text-gray-700">Forma płatności:</label>
        <multiselect-input v-model="form.payment_method" :options="payment_methods" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
      </search-filter>

    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-4">ID</th>
          <th class="px-3 pt-6 pb-4">Kontrahent</th>
          <th class="px-3 pt-6 pb-4">Umowa</th>
          <th class="px-3 pt-3 pb-2">Liczba<br>pozycji</th>
          <th class="px-3 pt-3 pb-2">Wartość<br>netto</th>
          <th class="px-3 pt-6 pb-4">Uwagi</th>
          <th class="px-3 pt-3 pb-2" colspan="2">Ostatnio<br>wystawiono</th>
        </tr>
        <tr v-for="facture in factures.data" :key="facture.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50':facture.deleted_at != null}">
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">
                <span>
                  {{ facture.id }}
                  <icon v-if="facture.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
                </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">
              {{ facture.firma }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">
              {{ facture.contract_number }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-end focus:text-shtax-500" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">
              {{ facture.num_of_pos }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-end focus:text-shtax-500" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">
              {{ facture.net_value }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">
              {{ facture.uwagi }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">
              <span v-if="facture.last_dh" :class="{'text-shtax-500':facture.last_dh.ile_dni>60, 'text-yellow-500':facture.last_dh.ile_dni>30&&facture.last_dh.ile_dni<=60}">
                {{ facture.last_dh.NUMER }} w {{ facture.last_dh.DATA_SPRZEDAZY }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="factures.data.length === 0">
          <td class="border-t px-3 py-2" colspan="8">Nie znaleziono faktur.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-3" :links="factures.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Faktury' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    MultiselectInput
  },
  layout: Layout,
  props: {
    filters: Object,
    factures: Object,
    storerooms: Array,
    contracts: Array,
    payment_methods: Array
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        storeroom: this.filters.storeroom,
        contract: this.filters.contract,
        payment_method: this.filters.payment_methods
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('factures'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  }
}
</script>
